import Login from "../components/Login";

const authenticationRoutes = [
    {
        path: '/auth/login',
        component: Login
    },
]

export default authenticationRoutes;